export default __webpack_public_path__ + "static/media/DrillingImg.7597c772.jpg";